import React, { FC, JSX, useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle } from '@mui/material';

type Props = {
  children: React.ReactElement<{ onClick?: () => void }>;
  onConfirm: () => void;
  title: string;
  content: JSX.Element | null;
  confirmBtnText?: string;
  isLoading?: boolean;
};

const ConfirmationBtnActionModal: FC<Props> = ({
  onConfirm,
  children,
  title,
  content,
  isLoading,
  confirmBtnText = 'Confirm',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const triggerButton = React.cloneElement(children, {
    onClick: () => {
      children.props.onClick?.();
      setIsOpen(true);
    },
  });

  const handleClose = () => setIsOpen(false);

  useEffect(() => {
    if (!isLoading && isSubmitted) {
      setIsSubmitted(false);
      setIsOpen(false);
    }
  }, [isLoading, isSubmitted]);

  return (
    <>
      {triggerButton}
      {isOpen && (
        <Dialog onClose={handleClose} open={isOpen}>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>{content}</DialogContent>
          <Box
            display="flex"
            justifyContent="flex-end"
            height="40px"
            m="5px 10px"
            sx={{ gap: '10px' }}
          >
            <Button disabled={isLoading} onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              loading={isLoading}
              onClick={() => {
                onConfirm();
                setIsSubmitted(true);
              }}
            >
              {confirmBtnText}
            </Button>
          </Box>
        </Dialog>
      )}
    </>
  );
};
export default ConfirmationBtnActionModal;
